module.exports = __webpack_public_path__ + "static/service18-77318c8fdd755d4662d5549b0bdc9d58.jpg";